import { Dayjs } from 'dayjs';
import QueryString from 'qs';
import { API } from '~apis/axios/instance';
import { RecommendFilter } from '~apis/cash-flow-overview/transactions/getTransactions';
import { ResponseBaseWithData } from '~types/response';

export const getRecommendFilters = (companyId: string, startDate: Dayjs, endDate: Dayjs) => {
  const query = QueryString.stringify(
    {
      startDate: startDate.format('YYYY-MM-DD'),
      endDate: endDate.format('YYYY-MM-DD'),
    },
    { arrayFormat: 'repeat' },
  );
  return API.get<
    ResponseBaseWithData<{
      items: RecommendFilter[];
    }>
  >(`/api/v2/companies/${companyId}/labelling/recommend-filters?${query}`);
};
